<script>
import MyLeave from '@/views/pages/hrms/my-leave.vue';
import AdminLeave from '@/views/pages/hrms/admin-leave.vue';

export default {
components: { MyLeave, AdminLeave }, 
  computed: {
    isAdmin() {
      try {
        const u = JSON.parse(localStorage.getItem('auth_user')) || {};
        return u.type === 'ADMIN' || u.role?.is_hr === true;
      }
      catch { return false; }
    },
  },
};
</script>

<template>
  <my-leave v-if="!isAdmin" />
  <admin-leave v-else /> 
</template>